import { GridColumnMenu, GridColumnMenuProps } from "@mui/x-data-grid-pro";
import { DiagnosticSettingsSlotProps } from "../../models/CustomColumnMenuProps";
import DateIntervalMenu from "./DateIntervalMenu";
import IncludeDismissedEventsMenuItem from "./IncludeDismissedEventsMenuItem";
import IntervalMenu from "./IntervalMenu";
import NumberPrecisionMenuItem from "./NumberPrecisionMenuItem";
import RenameColumnMenuItem from "./RenameColumnMenuItem";
import StatusColorMenu from "./StatusColorMenu";

// Need this extra component, because putting each component in a slot adds dividers
function DiagnosticSettingsSlot(props: DiagnosticSettingsSlotProps) {
  return (
    <>
      <RenameColumnMenuItem {...props} />
      <NumberPrecisionMenuItem {...props} />
      <IntervalMenu {...props} />
    </>
  );
}

function StatusCodeSlot(props: DiagnosticSettingsSlotProps) {
  return (
    <>
      <StatusColorMenu {...props} />
    </>
  );
}

function ColumnRenameSlot(props: DiagnosticSettingsSlotProps) {
  return (
    <>
      <RenameColumnMenuItem {...props} />
    </>
  );
}

function CalibrationSlot(props: DiagnosticSettingsSlotProps) {
  return (
    <>
      <RenameColumnMenuItem {...props} />
      <DateIntervalMenu {...props} />
    </>
  );
}

export default function ColumnMenu(props: GridColumnMenuProps) {
  const { colDef } = props;

  const field = colDef.field;

  // Maintenance
  if (field === "statusCode") {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          statusCodeSlot: StatusCodeSlot,
        }}
        slotProps={{
          statusCodeSlot: {
            displayOrder: 15,
            field,
          },
        }}
      />
    );
  }

  if (field === "warnings") {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          includeDismissedEvents: IncludeDismissedEventsMenuItem,
          renameColumn: ColumnRenameSlot,
        }}
        slotProps={{
          renameColumn: {
            displayOrder: 15,
            field,
          },
        }}
      />
    );
  }

  if (field === "calibration") {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          calibrationSlot: CalibrationSlot,
        }}
        slotProps={{
          calibrationSlot: {
            displayOrder: 15,
            field,
          },
        }}
      />
    );
  }

  if (colDef.type !== "number") {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          renameColumn: ColumnRenameSlot,
        }}
        slotProps={{
          renameColumn: {
            displayOrder: 15,
            field,
          },
        }}
      />
    );
  }

  return (
    <GridColumnMenu
      {...props}
      slots={{
        diagnosticSettingsSlot: DiagnosticSettingsSlot,
      }}
      slotProps={{
        diagnosticSettingsSlot: {
          displayOrder: 15,
          field,
        },
      }}
    />
  );
}
